import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { useTranslation } from "react-i18next";

const FixedAssetDetailLocation = () => {
  const { t } = useTranslation();
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Location (WareHouse)")} fieldName={"locationWarehouse"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("ResponsiblePerson")} fieldName={"responsiblePerson"} />
        </Col>
      </Row>

      <button type="button" className="btn btn-link">
        Placement
      </button>
    </>
  );
};

export default FixedAssetDetailLocation;
